export const CertificateDegree = {
  B1: 100,
  B2: 200,
  C1: 300,
  C2: 400,
}
export const CertificateDegreeList = [
  { id: CertificateDegree.B1, name: 'B1' },
  { id: CertificateDegree.B2, name: 'B2' },
  { id: CertificateDegree.C1, name: 'C1' },
  { id: CertificateDegree.C2, name: 'C2' },
]
